import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SilkIconWrapperNew,
    SilkIconWrapperSecondary,
} from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelection.style';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';
import {
    ImageDeviceSetType,
    ImageType,
} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers.type';
import { useCommon } from 'src/domains/common/Common';

interface LazyImageSilkPropsType {
    imgBase: ImageType;
    alt?: string;
    className?: string;
    imgDeviceSet?: ImageDeviceSetType;
    placeholder?: boolean;
}

export const LazyImageSilk = observer('LazyImageSilk', (props: LazyImageSilkPropsType) => {
    const commmon = useCommon();
    const { unifiedSportEventsTable } = commmon.features;
    const { alt, imgBase, className, placeholder, imgDeviceSet } = props;

    if (imgBase.src === '') {
        if (unifiedSportEventsTable) {
            return <SilkIconWrapperSecondary />;
        }
        return <SilkIconWrapperNew />;
    }

    return (
        <LazyImage
            alt={alt}
            imgBase={imgBase}
            className={className}
            placeholder={placeholder}
            imgDeviceSet={imgDeviceSet}
        />
    );
});
